<template>
  <div class="viewcontent" v-if="translations.event">
    <div>
      <h2>
        {{ translations.event.title_current }}
        <Info color="#007bff" @click="changeShowInfo()" class="info"/>
      </h2>
      <hr class="bg-secondary border-2 border-top border-secondary" />
      <div class="info--alert">
        <Alert :message="translations.info.event_add" v-if="showAlert" />
      </div>
      <div class="eventcont">
        <Event :eventtype="'add'" />
        <Event
          :eventtype="'current'"
          v-for="(item, index) in checkCurrent"
          :key="index"
          :info="item"
        />
      </div>
    </div>
    <div v-if="events.historical && events.historical.length > 0">
      <h2>
        {{ translations.event.title_historical }}
      </h2>
      <hr class="bg-secondary border-2 border-top border-secondary" />
      <div class="eventcont">
        <Event
          :eventtype="'historical'"
          v-for="(item, index) in events.historical"
          :key="index"
          :info="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Event from '@/components/Event.vue'
  import Info from '@/assets/icon/info.vue'
  import Alert from '../components/atoms/Alert.vue'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'Events',
    components: {
      Event,
      Alert,
      Info
    },
    data() {
      return {
        showInfo: false
      }
    },
    computed: {
      ...mapState(['events', 'translations', 'files', 'pay']),
      checkCurrent() {
        return this.events.current && this.events.current.length > 0
          ? this.events.current
          : null
      },
      showAlert() {
        const {current, historical} = this.events
        return this.showInfo || (current?.length === 0 && historical?.length === 0) 
      }
    },
    methods: {
      ...mapActions(['getEvents', 'resetEvents']),
      changeShowInfo() {
        this.showInfo = !this.showInfo
      }
    },
    
    created() {
      this.getEvents()
    },
    beforeUnmount() {
      this.resetEvents()
    },
  }
</script>

<style scoped>
  hr {
    margin: 1rem 0;
    color: inherit;
    background-color: currentColor;
    border: 0;
    opacity: 0.25;
  }
  .info {
    cursor: pointer;
  }
  .info--alert {
    padding: 10px;
  }
</style>
